module.exports = __webpack_public_path__ + "img/1557614104130166785.5f45e85f.png";